import { h, render } from 'preact';
import Slider from '../slider';
import ProductCard from '../product-card/product-card';

export default (element, { products, isB2B }) => {
  const container = element.querySelector('[data-product-recommendations-slider]');
  const prevEl = element.querySelector('[data-arrow-recommendations-left]');
  const nextEl = element.querySelector('[data-arrow-recommendations-right]');
  if (!container || !products.length) return;

  const ProductRecommendations = () => (
    <div className="swiper-wrapper">
      {
        products.map((product) => {
          const classes = `swiper-slide !h-auto pb-2
            [&>a>div:first-child]:h-54.25 [&>a>div:first-child>img]:h-full
            lg:[&>a>div:first-child]:h-113.5 lg:pb-4
            ${product.metafields.portrait === true ? '!w-41 lg:!w-85.75' : '!w-82 lg:!w-171.5'}
          `;

          return (
            <ProductCard
              key={product.id}
              product={product}
              classes={classes}
							isB2B={isB2B}
            />
          );
        })
      }
    </div>
  );

  const renderRecommendations = () => {
    render(
      <ProductRecommendations />,
      container,
    );
  };

  const initSlider = () => {
    // eslint-disable-next-line no-new
    new Slider({
      el: container,
      options: {
        slidesPerView: "auto",
        spaceBetween: 4,
        loop: false,
        breakpoints: {
          1024: {
            spaceBetween: 8,
            slidesPerGroupAuto: true,
            slidesPerView: 'auto',
          }
        },
        navigation: {
          nextEl,
          prevEl,
        }
      },
    });

    // show content when it's ready
    container.classList.remove('sr-only');
  };

  const init = () => {
    renderRecommendations();
    initSlider();
  };

  init();
};
